import Title from "../Title/Title";
import PartnerCard from "./PartnerCard";
import styles from "./Partners.module.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import RightArrow from "../../../../modules/pages/home/collaborators/components/RightArrow";
import LeftArrow from "../../../../modules/pages/home/collaborators/components/LeftArrow";

function Partners({ title, partners }) {
  const responsive = {
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 768, min: 576 },
      items: 2,
    },
    miniDesktop: {
      breakpoint: { max: 1200, min: 768 },
      items: 2,
    },
    desktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 2,
    },
  };

  return (
    <section className={styles.partners}>
      <Title titleText={title} />

      <Carousel
        responsive={responsive}
        customRightArrow={<RightArrow />}
        customLeftArrow={<LeftArrow />}
        renderArrowsWhenDisabled={true}
        autoPlay={true}
        autoPlaySpeed={2000}
        infinite={true}
        className={styles.list}
        rtl={true}
      >
        {partners.map(partner => (
          <PartnerCard key={`partners-${partner.id}`} {...partner} />
        ))}
      </Carousel>
    </section>
  );
}

export default Partners;
